// extracted by mini-css-extract-plugin
export default {"section__header":"SectionHeader_section__header__f-2+U"};